// Generouted, changes to this file will be overriden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/admin_invoice_reports`
  | `/ai_agent_setting`
  | `/ai_service_setting`
  | `/approving_invoice_reports`
  | `/approving_invoice_reports/:report_id/edit`
  | `/business_document_setting`
  | `/business_documents`
  | `/debug`
  | `/export_files`
  | `/foreign_currency_settings`
  | `/foreign_currency_settings/:currency`
  | `/import_export_histories`
  | `/invoice_reports`
  | `/ip_address_whitelists`
  | `/notification_setting`
  | `/office_withdrawal`
  | `/received_invoices`
  | `/reconciliation_service_setting`
  | `/report_types/:report_type_id/admin_invoice_reports/:report_id/edit`
  | `/report_types/:report_type_id/invoice_reports/:report_id/edit`
  | `/report_types/:report_type_id/transaction_items`
  | `/report_types/:report_type_id/transaction_items/:transaction_item_id`
  | `/term_of_use_agent_bpo_receives`

export type Params = {
  '/approving_invoice_reports/:report_id/edit': { report_id: string }
  '/foreign_currency_settings/:currency': { currency: string }
  '/report_types/:report_type_id/admin_invoice_reports/:report_id/edit': { report_type_id: string; report_id: string }
  '/report_types/:report_type_id/invoice_reports/:report_id/edit': { report_type_id: string; report_id: string }
  '/report_types/:report_type_id/transaction_items': { report_type_id: string }
  '/report_types/:report_type_id/transaction_items/:transaction_item_id': { report_type_id: string; transaction_item_id: string }
}

export type ModalPath = never

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
